// src/store/slices/gpIncomeExpenseReportSlice.js

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/AxiosInstance";

export const fetchGpIncomeExpenseReportThunk = createAsyncThunk(
  "reports/gpIncomeExpenseReport",
  async (params = {}, { rejectWithValue }) => {
    try {
      const res = await api.get("/api/reports/gp-income-expense-report", {
        params: {
          from_date: params.from_date || "",
          to_date: params.to_date || "",
          district_id: params.district_id || "",
          taluk_id: params.taluk_id || "",
          pan_id: params.pan_id || "",
        },
      });

      if (!res.data?.success) {
        return rejectWithValue(res.data?.message || "Failed to load report");
      }

      return res.data?.data || [];
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || err.message || "Server error"
      );
    }
  }
);

const gpIncomeExpenseReportSlice = createSlice({
  name: "gpIncomeExpenseReport",
  initialState: {
    rows: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearGpIncomeExpenseReport(state) {
      state.rows = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGpIncomeExpenseReportThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGpIncomeExpenseReportThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.rows = action.payload || [];
      })
      .addCase(fetchGpIncomeExpenseReportThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to load report";
      });
  },
});

export const { clearGpIncomeExpenseReport } =
  gpIncomeExpenseReportSlice.actions;

export default gpIncomeExpenseReportSlice.reducer;